export enum CheckoutMode {
    Full = 'full',
    Partial = 'partial',
}
